export type LatestFrameRestoreInput = {
  frameItems?: readonly { id: string }[] | undefined;
  hasStoredSession: boolean;
  isSharedReadOnly: boolean;
  loadedFrameRecordId?: string | null | undefined;
  searchFrameId?: string | undefined;
};

export function latestFrameIdToRestore({
  frameItems,
  hasStoredSession,
  isSharedReadOnly,
  loadedFrameRecordId,
  searchFrameId
}: LatestFrameRestoreInput): string | null {
  if (isSharedReadOnly || !hasStoredSession || searchFrameId || loadedFrameRecordId) {
    return null;
  }

  return frameItems?.[0]?.id ?? null;
}
